module.exports = __webpack_public_path__ + "phone.9c34a807f027bf73d39f.png";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/img/phone.png
// module id = ../../../../../src/assets/img/phone.png
// module chunks = styles